




import { onPropertyChangedHandler } from './helpers'

export default {
	name: 'NumberProperty',
	props: {
		rootObject: {
			type: Object,
			required: true,
		},
		propertySeekDotNotation: {
			type: String,
			required: true,
		},
		propertyKey: {
			type: String,
			required: true,
		},
		propertyValue: {
			type: Number,
			required: true,
		},
		propertyChangedFn: {
			type: Function,
			default: undefined,
		},
	},
	data() {
		return {
			liveValue: this.propertyValue,
		}
	},
	methods: {
		onChange() {
			onPropertyChangedHandler(this.rootObject, this.propertySeekDotNotation, Number.parseFloat(this.liveValue))
			this.propertyChangedFn(this.rootObject, this.propertySeekDotNotation, this.liveValue)
		},
	},
}
